// extracted by mini-css-extract-plugin
export var table = "_z4-0";